import React, { Component } from 'react';

export default function spinnable(ComposedComponent) {
  class Spinnable extends Component {
    // $FlowIgnore
    state: Object = { isSpinning: false };

    // $FlowIgnore
    setIsSpinning: Function = (spinning: boolean) => {
      this.setState({isSpinning: spinning});
    };

    render() {
      return (
        <ComposedComponent
          { ...this.state }
          { ...this.props }
          isSpinning = { this.state.isSpinning }
          setIsSpinning = { this.setIsSpinning }
        />
      );
    }
  }
  return Spinnable;
}
